// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1816) return "static/chunks/1816-8b5fd8bffac6b94a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"748":"dbe6523c86c8586d","1185":"cb45a317af7b19d8","1189":"b4f3b76a030f6384","2086":"010e5d79f7c39696","3029":"20b10d617f129958","3952":"e8aad0f46bf014f7","4841":"d192a5b909f142e0","7412":"436becd63af20773","7875":"b53bef3fccfa8d3c"}[chunkId] + ".js";
};